import { z } from "zod";

export const statsSchema = z.object({
  impressions: z.number().nullable(),
  impressions_prev: z.number().nullable(),
  impressions_delta: z.number().nullable(),
  impressions_percent: z.number().nullable(),

  clicks: z.number().nullable(),
  clicks_prev: z.number().nullable(),
  clicks_delta: z.number().nullable(),
  clicks_percent: z.number().nullable(),

  conversion: z.number().nullable(),
  conversion_prev: z.number().nullable(),
  conversion_delta: z.number().nullable(),
  conversion_percent: z.number().nullable(),

  cost: z.number().nullable(),
  cost_prev: z.number().nullable(),
  cost_delta: z.number().nullable(),
  cost_percent: z.number().nullable(),

  attributed_conversions_7d: z.number().nullable(),
  attributed_conversions_7d_prev: z.number().nullable(),
  attributed_conversions_7d_delta: z.number().nullable(),
  attributed_conversions_7d_percent: z.number().nullable(),

  attributed_units_ordered_7d: z.number().nullable(),
  attributed_units_ordered_7d_prev: z.number().nullable(),
  attributed_units_ordered_7d_delta: z.number().nullable(),
  attributed_units_ordered_7d_percent: z.number().nullable(),

  attributed_sales_7d: z.number().nullable(),
  attributed_sales_7d_prev: z.number().nullable(),
  attributed_sales_7d_delta: z.number().nullable(),
  attributed_sales_7d_percent: z.number().nullable(),

  attributed_conversions_7d_same_sku: z.number().nullable(),
  attributed_conversions_7d_same_sku_prev: z.number().nullable(),
  attributed_conversions_7d_same_sku_delta: z.number().nullable(),
  attributed_conversions_7d_same_sku_percent: z.number().nullable(),

  attributed_units_ordered_7d_same_sku: z.number().nullable(),
  attributed_units_ordered_7d_same_sku_prev: z.number().nullable(),
  attributed_units_ordered_7d_same_sku_delta: z.number().nullable(),
  attributed_units_ordered_7d_same_sku_percent: z.number().nullable(),

  attributed_sales_7d_same_sku: z.number().nullable(),
  attributed_sales_7d_same_sku_prev: z.number().nullable(),
  attributed_sales_7d_same_sku_delta: z.number().nullable(),
  attributed_sales_7d_same_sku_percent: z.number().nullable(),

  total_sales: z.number().nullable(),
  total_sales_prev: z.number().nullable(),
  total_sales_delta: z.number().nullable(),
  total_sales_percent: z.number().nullable(),

  ad_sales: z.number().nullable(),
  ad_sales_prev: z.number().nullable(),
  ad_sales_delta: z.number().nullable(),
  ad_sales_percent: z.number().nullable(),

  ad_sales_same_sku: z.number().nullable(),
  ad_sales_same_sku_prev: z.number().nullable(),
  ad_sales_same_sku_delta: z.number().nullable(),
  ad_sales_same_sku_percent: z.number().nullable(),

  total_units: z.number().nullable(),
  total_units_prev: z.number().nullable(),
  total_units_delta: z.number().nullable(),
  total_units_percent: z.number().nullable(),

  cost_per_click: z.number().nullable(),
  cost_per_click_prev: z.number().nullable(),
  cost_per_click_delta: z.number().nullable(),
  cost_per_click_percent: z.number().nullable(),

  click_thru_rate: z.number().nullable(),
  click_thru_rate_prev: z.number().nullable(),
  click_thru_rate_delta: z.number().nullable(),
  click_thru_rate_percent: z.number().nullable(),

  conv_rate: z.number().nullable(),
  conv_rate_prev: z.number().nullable(),
  conv_rate_delta: z.number().nullable(),
  conv_rate_percent: z.number().nullable(),

  acos: z.number().nullable(),
  acos_prev: z.number().nullable(),
  acos_delta: z.number().nullable(),
  acos_percent: z.number().nullable(),

  roas: z.number().nullable(),
  roas_prev: z.number().nullable(),
  roas_delta: z.number().nullable(),
  roas_percent: z.number().nullable(),

  acos_same_sku: z.number().nullable(),
  acos_same_sku_prev: z.number().nullable(),
  acos_same_sku_delta: z.number().nullable(),
  acos_same_sku_percent: z.number().nullable(),

  roas_same_sku: z.number().nullable(),
  roas_same_sku_prev: z.number().nullable(),
  roas_same_sku_delta: z.number().nullable(),
  roas_same_sku_percent: z.number().nullable(),

  aaov: z.number().nullable(),
  aaov_prev: z.number().nullable(),
  aaov_delta: z.number().nullable(),
  aaov_percent: z.number().nullable(),

  aauv: z.number().nullable(),
  aauv_prev: z.number().nullable(),
  aauv_delta: z.number().nullable(),
  aauv_percent: z.number().nullable(),

  ssaov: z.number().nullable(),
  ssaov_prev: z.number().nullable(),
  ssaov_delta: z.number().nullable(),
  ssaov_percent: z.number().nullable(),

  ssauv: z.number().nullable(),
  ssauv_prev: z.number().nullable(),
  ssauv_delta: z.number().nullable(),
  ssauv_percent: z.number().nullable(),

  average_daily_spend: z.number().nullable(),
  average_daily_spend_prev: z.number().nullable(),
  average_daily_spend_delta: z.number().nullable(),
  average_daily_spend_percent: z.number().nullable(),

  average_daily_sales: z.number().nullable(),
  average_daily_sales_prev: z.number().nullable(),
  average_daily_sales_delta: z.number().nullable(),
  average_daily_sales_percent: z.number().nullable(),

  day_range: z.number().nullable(),
});

export const merchStatsSchema = z.object({
  total_conv_rate: z.number().nullable(),
  total_conv_rate_prev: z.number().nullable(),
  total_conv_rate_delta: z.number().nullable(),
  total_conv_rate_percent: z.number().nullable(),

  profit: z.number().nullable(),
  profit_prev: z.number().nullable(),
  profit_delta: z.number().nullable(),
  profit_percent: z.number().nullable(),

  profit_wo_adspend: z.number().nullable(),
  profit_wo_adspend_prev: z.number().nullable(),
  profit_wo_adspend_delta: z.number().nullable(),
  profit_wo_adspend_percent: z.number().nullable(),

  conversion_same_sku: z.number().nullable(),
  conversion_same_sku_prev: z.number().nullable(),
  conversion_same_sku_delta: z.number().nullable(),
  conversion_same_sku_percent: z.number().nullable(),

  page_views: z.number().nullable(),
  page_views_prev: z.number().nullable(),
  page_views_delta: z.number().nullable(),
  page_views_percent: z.number().nullable(),

  total_cogs: z.number().nullable(),
  total_cogs_prev: z.number().nullable(),
  total_cogs_delta: z.number().nullable(),
  total_cogs_percent: z.number().nullable(),

  margin: z.number().nullable(),
  margin_prev: z.number().nullable(),
  margin_delta: z.number().nullable(),
  margin_percent: z.number().nullable(),

  margin_wo_adspend: z.number().nullable(),
  margin_wo_adspend_prev: z.number().nullable(),
  margin_wo_adspend_delta: z.number().nullable(),
  margin_wo_adspend_percent: z.number().nullable(),

  roms: z.number().nullable(),
  roms_prev: z.number().nullable(),
  roms_delta: z.number().nullable(),
  roms_percent: z.number().nullable(),

  total_cost: z.number().nullable(),
  total_cost_prev: z.number().nullable(),
  total_cost_delta: z.number().nullable(),
  total_cost_percent: z.number().nullable(),

  organic_sales: z.number().nullable(),
  organic_sales_prev: z.number().nullable(),
  organic_sales_percent: z.number().nullable(),
  organic_sales_delta: z.number().nullable(),

  organic_units: z.number().nullable(),
  organic_units_prev: z.number().nullable(),
  organic_units_percent: z.number().nullable(),
  organic_units_delta: z.number().nullable(),

  organic_page_views: z.number().nullable(),
  organic_page_views_prev: z.number().nullable(),
  organic_page_views_percent: z.number().nullable(),
  organic_page_views_delta: z.number().nullable(),

  org_conv_rate: z.number().nullable(),
  org_conv_rate_delta: z.number().nullable(),
  org_conv_rate_prev: z.number().nullable(),

  total_roas: z.number().nullable(),
  total_roas_prev: z.number().nullable(),
  total_roas_delta: z.number().nullable(),
  total_roas_percent: z.number().nullable(),

  total_acos: z.number().nullable(),
  total_acos_prev: z.number().nullable(),
  total_acos_delta: z.number().nullable(),
  total_acos_percent: z.number().nullable(),

  taov: z.number().nullable(),
  taov_prev: z.number().nullable(),
  taov_delta: z.number().nullable(),
  taov_percent: z.number().nullable(),

  tauv: z.number().nullable(),
  tauv_prev: z.number().nullable(),
  tauv_delta: z.number().nullable(),
  tauv_percent: z.number().nullable(),

  top_of_search_impression_share: z.number().nullable().optional(),
  top_of_search_impression_share_prev: z.number().nullable().optional(),
  top_of_search_impression_share_delta: z.number().nullable().optional(),
  top_of_search_impression_share_percent: z.number().nullable().optional(),

  rating: z.number().nullable().optional(),
  rating_prev: z.number().nullable().optional(),
  rating_delta: z.number().nullable().optional(),
  rating_percent: z.number().nullable().optional(),

  ratings_total: z.number().nullable().optional(),
  ratings_total_prev: z.number().nullable().optional(),
  ratings_total_delta: z.number().nullable().optional(),
  ratings_total_percent: z.number().nullable().optional(),
});
